import React, { useEffect, useState } from "react";
import styles from "./BusinessDetails.module.scss";
import NavBar from "../../components/navbar/NavBar";
import FilterModal from "../../components/filterConfig/FilterModal";
import dayjs, { Dayjs } from "dayjs";
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from "../../util/datefunction";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import PaginationTable from "../../components/paginatedTable/pagination-table";
import TableHeader from "../../components/TableHeader/TableHeader";
import { useHistory, useParams } from "react-router-dom";
import { openModalAndSetContent } from "../../redux/actions/modal/modalActions";
import AddPaymentRoute from "./AddPaymentRoute/AddPaymentRoute";
import {
	ColumnPaymentRoutesModule,
	PaymentRoutesData,
} from "../../types/PaymentRoute";
import StatusView from "../StatusView/StatusView";

function PaymentRoute() {
	const { id } = useParams<any>();

	const [tableRow, setTableRow] = useState<any[]>();
	const [businesses, setBusinesses] = useState<any>();
	const [contentAction, setContentAction] = useState<any>({});
	const history = useHistory();

	const { modalOpened } = useSelector((state) => state.modal);

	const dispatch = useDispatch();
	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(300);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	//FILTERING
	const [value, setValue] = useState("");
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState("");
	const [fromDate, setFromDate] = useState<Dayjs | null | string>("");
	const [toDate, setToDate] = useState<Dayjs | null | string>("");
	const [country, setCountry] = useState("");
	const [status, setStatus] = useState("");
	const [email, setEmail] = useState("");

	const [bearer, setBearer] = useState(false);

	const clearHandler = () => {
		setEventDate("");
		setFromDate("");
		setToDate("");
		setCountry("");
		setStatus("");
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === "today") {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === "last7days") {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "last30days") {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "oneyear") {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate("");
			setToDate("");
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: "Status",
			value: status,
			setValue: setStatus,
			selective: [{ name: "YES" }, { name: "NO" }],
		},
	];

	const fetchPaymentRoute = async () => {
		dispatch(openLoader());
		setLoading(true);
		try {
			const data = await axios.get(
				`/v1/business/${id}/payment/route?search=${value}&perpage=${rowsPerPage}&page=${pageNumber}`
			);
			setBusinesses(data?.data);
			dispatch(closeLoader());
			setBearer(false);
			setLoading(false);
		} catch (error: any) {
			setLoading(false);
			dispatch(closeLoader());
			const message = error?.response?.data?.message;
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastType: "error",
					})
				)
			);
		}
	};

	useEffect(() => {
		fetchPaymentRoute();
	}, [bearer, value, pageNumber, rowsPerPage]);

	useEffect(() => {
		setPageNumber(businesses?.paymentproperty?.length || 1);
	}, [businesses]);

	const dataBusinesses = () => {
		const tempArr: PaymentRoutesData[] = [];
		businesses?.paymentroute
			?.slice(0)
			.reverse()
			.forEach((business: any, index: number) => {
				return tempArr.push({
					id: business?.id,
					type: business?.type,
					paymentmethod: business?.paymentmethod,
					authoption: business?.authoption,
					route: business?.route,
					scheme: business?.scheme,
					region: business?.region,
					currency: business?.currency,
					statusView: (
						<StatusView
							status={business?.status === "ACTIVE" ? "Active" : "InActive"}
							green="Active"
							red="InActive"
						/>
					),
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataBusinesses());
	}, [businesses?.paymentroute]);

	const addConfigHandler = (identifier: string) => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div className={styles.modalDiv}>
						<AddPaymentRoute
							id={id}
							content={contentAction}
							identifier={identifier}
							fetchPaymentRoute={fetchPaymentRoute}
						/>
					</div>
				),
			})
		);
	};

	const editConfigHandler = (identifier: string) => {
		dispatch(
			openModalAndSetContent({
				modalStyles: {
					padding: 0,
				},
				modalContent: (
					<div className={styles.modalDiv}>
						<AddPaymentRoute
							id={id}
							content={contentAction}
							identifier={identifier}
							fetchPaymentRoute={fetchPaymentRoute}
						/>
					</div>
				),
			})
		);
	};

	useEffect(() => {
		Object.values(contentAction).length > 0 && editConfigHandler("Edit");
	}, [contentAction]);

	useEffect(() => {
		if (!modalOpened) setContentAction({});
	}, [modalOpened]);

	if (loading) {
		return <div />;
	}

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name="Payment Route" />
			<div className={styles.containerBusiness}>
				<div className={styles.containerHeader}>
					<TableHeader
						pageName=""
						data={businesses?.businessUsers}
						dataLength={businesses?.paymentproperty?.length}
						value={value}
						setValue={setValue}
						dropdown={dropdown}
						exporting={false}
						setDropdown={setDropdown}
						placeHolder="Search"
						newButton={
							<div
								onClick={() => addConfigHandler("Add")}
								className={styles.addButton}
							>
								Add payment route
							</div>
						}
						FilterComponent={
							<FilterModal
								eventDate={eventDate}
								setEventDate={setEventDate}
								dropdown={dropdown}
								setDropdown={setDropdown}
								setFromDate={setFromDate}
								setToDate={setToDate}
								fromDate={fromDate}
								toDate={toDate}
								setBearer={setBearer}
								clearHandler={clearHandler}
								filteredArray={filteredArray}
							/>
						}
					/>

					<PaginationTable
						data={tableRow ? tableRow : []}
						columns={ColumnPaymentRoutesModule ? ColumnPaymentRoutesModule : []}
						emptyPlaceHolder={
							businesses?.paymentroute?.length === 0
								? "No record found"
								: "Loading..."
						}
						value={value}
						total={businesses?.paymentroute?.length}
						totalPage={0}
						pageNumber={pageNumber}
						setPageNumber={setPageNumber}
						nextPage={nextPage}
						setNextPage={setNextPage}
						previousPage={previousPage}
						setPreviousPage={setPreviousPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						setBearer={setBearer}
						clickAction={true}
						setContentAction={setContentAction}
						recent={false}
					/>
				</div>
			</div>
		</div>
	);
}

export default PaymentRoute;
